export default __webpack_public_path__ + "static/media/a5.c8edd7f0.png";